<script lang="ts" setup>
import { computed } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import cpp1jpeg from '@core/assets/image/qrcode/newuser/cpp_31.png';
import cpp2jpeg from '@core/assets/image/qrcode/newuser/cpp_32.png';
import cpp3jpeg from '@core/assets/image/qrcode/newuser/cpp_33.png';
import cpp4jpeg from '@core/assets/image/qrcode/newuser/cpp_34.png';
import { ProfileService } from '@core/services/profile.service';

const service = useService(ProfileService);
const qrcodeList = [cpp1jpeg, cpp2jpeg, cpp3jpeg, cpp4jpeg];

const qrcode = computed(() => {
  return qrcodeList[service.programLevel - 1] || qrcodeList[0];
});

const eventData = computed(() => ({
  sub_type: `${service.programLevel}`,
}));

function handleClose() {
  service.newUserAddTeacherVisible = false;
}
</script>

<template>
  <a-modal
    v-model:open="service.newUserAddTeacherVisible"
    :width="500"
    :footer="null"
    :closable="false"
    :mask-closable="false"
    :destroy-on-close="true"
    :centered="true"
    wrap-class-name="plain-modal"
  >
    <div v-track:oj_show_newuser_drainage="eventData">
      <div class="bg-add-teacher-modal relative z-20 h-[516px] w-[500px]">
        <div class="absolute h-[176px] w-[176px] right-[60px] top-[216px]">
          <img :src="qrcode" alt="qrcode" />
        </div>
      </div>
      <div class="leading-[22px] text-sm text-colorTextWhite mt-6 mb-4 text-center">*扫码领课不用担心会跳出核桃OJ页面哦~</div>
      <div class="mx-auto h-9 w-9 flex-center cursor-pointer" @click="handleClose">
        <img
          class="h-6 w-6"
          src="@core/assets/image/goods-result-modal/icon-close.svg"
          alt="close"
        />
      </div>
    </div>
  </a-modal>
</template>

<style scoped>
.bg-add-teacher-modal {
  background: url(@core/assets/image/qrcode/newuser/box-v3@2x.png) 0 0 no-repeat;
  background-size: 100% 100%;
}
</style>
